import { AlertTypes, LoadingType, ModalType, SnackbarType } from '@app-types/app';

import { clippBodyHandler } from '@helpers/utils';

import { create } from 'zustand';

type UIStoreType = {
    modal: ModalType;
    loading: LoadingType;
    showLoading: (loadingMessage: string) => void;
    hideLoading: () => void;
    snackbar: SnackbarType;
    showSnackbar: (message: string, alertType?: AlertTypes, autoHideDuration?: number) => void;
    hideSnackbar: () => void;
};

export const uiStore = create<UIStoreType>((set) => ({
    modal: { isActive: false },
    loading: { show: false },
    showLoading: (loadingMessage: string) => {
        clippBodyHandler(true);
        set({
            loading: {
                message: loadingMessage,
                show: true,
            },
        });
    },
    hideLoading: () =>
        set(() => {
            clippBodyHandler(false);
            return { loading: { show: false } };
        }),
    snackbar: { show: false },
    showSnackbar: (message: string, alertType: AlertTypes = AlertTypes.INFO, autoHideDuration = 4000) => {
        set({
            snackbar: {
                message: message,
                show: true,
                alertType,
                autoHideDuration,
            },
        });
    },
    hideSnackbar: () => set({ snackbar: { show: false } }),
}));
